export default __webpack_public_path__ + "static/media/mt2.9c8b3928.png";